// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Vd2oT","colBig":"styles_colBig__1_9qp","colSmall":"styles_colSmall__1hIX8"};